module.exports = __webpack_public_path__ + "img/20Y30G2.f59c192b.png";